export default __webpack_public_path__ + "static/media/world-wide.1bb2347d.png";